export default "images/univ-bsi.jpg";